import React, { PureComponent } from "react";
import Link from "next/link";
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import ReactMarkdown from "react-markdown";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);

import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  VKIcon,
  VKShareButton,
} from "react-share";
import readingTime from "reading-time";

import { LOCAL_TOGGLE_OVERLAY_MUTATION } from "../../../../apollo-state/graphql/mutations";

import PageHeading from "../../../../components/page-heading/page-heading";
import Head from "../../../../components/head-data/head-data";
import Cta from "../../../../components/cta/cta";
import NotFound from "../../../../components/not-found/not-found";

import getParameterByName from "../../../../utils/get-url-param-by-name";

import "./index.scss";

const APPROVE_BLOG_POST = gql`
  mutation APPROVE_BLOG_POST($slug: String) {
    approveBlogPost(slug: $slug) {
      success
    }
  }
`;

const BLOG_ARTICLE_QUERY = gql`
  query BLOG_ARTICLE_QUERY($slug: String) {
    blogArticle(where: { slug: $slug }) {
      id
      date
      title
      previewPicUrl
      previewPicAlt
      previewPicUrlSocial
      slug
      body
      shortDescription
      approved
    }
  }
`;

class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      approvedState: false,
    };
  }
  setApproved = () => {
    this.setState(
      {
        approvedState: true,
      },
      () => alert("Article now live")
    );
  };
  render() {
    const { query, me } = this.props;
    const backToPage = getParameterByName("pageidxref");
    const approval = getParameterByName("approval");
    const { approvedState } = this.state;
    return (
      <Query query={BLOG_ARTICLE_QUERY} variables={{ slug: query.slug }}>
        {({ data, loading }) => {
          if (loading) return <p>loading...</p>;
          // unknown, or a draft (only admins see those)
          if (!data || !data.blogArticle) {
            return (
              <NotFound
                title="We couldn't find that post"
                body="The link may be wrong, or the post may have moved."
                href="/blog"
                linkText="See all posts"
              />
            );
          }
          const {
            body,
            title,
            previewPicUrl,
            previewPicAlt,
            date,
            slug,
            previewPicUrlSocial,
            shortDescription,
            approved,
          } = data?.blogArticle;

          return (
            <div className="index">
              <Head
                title={title}
                description={shortDescription}
                url={`https://www.foundercloud.com/blog/post/${slug}`}
                ogImage={previewPicUrlSocial}
              />
              <PageHeading
                title={title}
                showImage
                src={previewPicUrl}
                alt={previewPicAlt}
                subHeader={readingTime(body).text}
              />
              <div className="page__grid">
                <div className="blog-article">
                  <div className="blog-article__inner">
                    <Link
                      as={`/blog/${
                        process.browser && backToPage && backToPage !== "1"
                          ? "page-" + backToPage
                          : ""
                      }`}
                      href={`/blog/${
                        process.browser && backToPage && backToPage !== "1"
                          ? "?slug=page-" + backToPage
                          : ""
                      }`}
                    >
                      <div className="blog-article__back">
                        <a>← Back to blog articles</a>
                      </div>
                    </Link>
                    {approval &&
                      me &&
                      me.hasAdminRights &&
                      !approved &&
                      !approvedState && (
                        <Mutation
                          mutation={APPROVE_BLOG_POST}
                          variables={{
                            slug,
                          }}
                          onCompleted={this.setApproved}
                        >
                          {(approveBlogPost, { error, loading, called }) => {
                            if (error) return <p>error...</p>;
                            return (
                              <center style={{ marginBottom: "40px" }}>
                                <Cta
                                  type="button"
                                  tag="button"
                                  text={
                                    loading
                                      ? "approving..."
                                      : "Approve blog post"
                                  }
                                  onClick={approveBlogPost}
                                  disabled={loading}
                                />
                              </center>
                            );
                          }}
                        </Mutation>
                      )}
                    <article className="blog-article__content">
                      <ReactMarkdown
                        source={body}
                        escapeHtml={false}
                        linkTarget="_blank"
                      />
                      <p className="blog-article__date">
                        <b>{dayjs(date).format("Do MMMM YYYY")}</b>
                      </p>
                    </article>
                    <div className="blog-article__share-cont">
                      <div className="pattern" />
                      <p>
                        Liked what you read? Share with someone else who may
                        find the article helpful!
                      </p>
                      <FacebookShareButton
                        url={`https://www.foundercloud.com/blog/post/${slug}`}
                      >
                        <FacebookIcon size={32} round={true} />
                      </FacebookShareButton>
                      <LinkedinShareButton
                        url={`https://www.foundercloud.com/blog/post/${slug}`}
                      >
                        <LinkedinIcon size={32} round={true} />
                      </LinkedinShareButton>
                      <TwitterShareButton
                        url={`https://www.foundercloud.com/blog/post/${slug}`}
                      >
                        <TwitterIcon size={32} round={true} />
                      </TwitterShareButton>
                      <VKShareButton
                        url={`https://www.foundercloud.com/blog/post/${slug}`}
                      >
                        <VKIcon size={32} round={true} />
                      </VKShareButton>
                    </div>
                  </div>
                </div>
              </div>
              {!me && (
                <div className="blog-article__sign-up">
                  <p>
                    Looking for a co-founder? Find one with FounderCloud! <br />
                    Click the link below and sign up for free today
                  </p>
                  <Mutation mutation={LOCAL_TOGGLE_OVERLAY_MUTATION}>
                    {(toggleOverlay) => (
                      <Cta
                        type="button"
                        tag="button"
                        text="Sign up free"
                        onClick={toggleOverlay}
                        args={{ type: "signup" }}
                      />
                    )}
                  </Mutation>
                </div>
              )}
            </div>
          );
        }}
      </Query>
    );
  }
}

export default Index;
